import { Grade as GradeType } from '@/externals/gyym/user/grades/types'

export type Grade = GradeType

// Gradeはサーバサイドで持っている `user_grade_hoge`
// Passはクライアントサイドで取り回しやすい形にしたもの
export enum PassKey {
  GREENY = 'greeny',
  BEGINNER = 'beginner',
  LIGHT = 'light',
  STANDARD = 'standard',
  SILVER = 'silver',
  GOLD = 'gold',
  PREMIUM = 'premium',
  VIP = 'vip',
  GYYM_MASTER = 'gyym_master',
}
